export default __webpack_public_path__ + "static/media/error-404.4c36b59d.svg";